import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import { FaPencilAlt,  FaFileUpload, FaTrashAlt } from "react-icons/fa";
import { API } from 'aws-amplify';
import { useToasts } from 'react-toast-notifications';
import Moment from 'react-moment';
import UploadFile from '../../../../components/UploadFile';
import './AssetDocs.css';

import { Formik } from "formik";
import * as yup from "yup";
import { useI18n } from '../../../../i18n';


const AssetDocs = (props) => {
    const { t } = useI18n();
    const [asset, setAsset] = useState([]);
    const [docs, setDocs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [upload, setUpload] = useState(false);
    const { addToast } = useToasts();
    const [file, setFile] = useState();
    const [selDoc, setSelDoc] = useState();
    const [selDocEdit, setSelDocEdit] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const handleClose = () => {setShowModal(false); setSelDoc()}
    const handleShow = (doc_no) => {setShowModal(true); setSelDoc(doc_no)}
    const [showModalEdit, setShowModalEdit] = useState(false);
    const handleCloseEdit = () => {setShowModalEdit(false); setSelDocEdit([])}
    const handleShowEdit = (doc) => {setShowModalEdit(true); setSelDocEdit(doc);}

    const params = { 
        headers: {
            'x-api-key': process.env.REACT_APP_API_KEY,        
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    }

    const getAsset = async () => {
        await API.get('assets','/' + props.assetId, params)
        .then(asset => {
            setAsset(asset);
        }).catch((err) => {
            console.log(err)
            addToast(t('toast.errorLoadingAssets'), { appearance: 'error' });
        });
    }

    // Get Asset from props
    useEffect(()=>{
        const loadAssets = async () => {
            await getAsset();
        }

        if (props.asset) {
            setAsset(props.asset);
        } else {
            loadAssets();
        }
    }, [props.asset]);

    // Get Docs from the Asset
    useEffect(()=>{
        let documents = [];
        asset.docs && asset.docs.forEach((item) => {
            const url =  item.url.split('/');
            item.filename = url[5];
            documents.push(item);
        });

        //sort array desc
        documents.sort((a, b) => (a.doc_no > b.doc_no) ? 1 : -1);
        documents.reverse();

        setDocs(documents);
        setLoading(false);
    }, [asset])

    // Form Submit
    const handleSubmit = async (data, { resetForm }) => {
        setUpload(true);
        let doc = {
            userId:  props.user.username,
            description: data.description,
            version: data.version,
        }

        // upload file
        if(file) {
            const imgPath = await UploadFile('img', '/', file, 'assets', props.site_ref);
            doc.url = imgPath;
            doc.doc_no = docs.length > 0 ? Math.max.apply(Math, docs.map(function(o) { return o.doc_no; })) + 1  : 1 
        }

        // console.log(doc)
        
        API.post('asset_docs', '/' + props.assetId, {      
            body: doc,
            headers: {
                'x-api-key': process.env.REACT_APP_API_KEY,        
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
        .then(res => {
            // console.log(res)
            setLoading(true);
            setFile();   
            addToast(t('toast.documentSaved'), { appearance: 'success' });  
            setUpload(false);     
            // resetForm();             
        }).catch(error => {
            console.log(error)
            addToast(t('toast.errorSavingDocument'), { appearance: 'error' });
            setUpload(false);
        }); 
    
    };

    const deleteDoc = (doc_no) => {
        //remove from db
        setShowModal(false);
        API.post('del_asset_docs', '/' + props.assetId, {      
            body: {
                doc_no: doc_no,
            },
            headers: {
                'x-api-key': process.env.REACT_APP_API_KEY,        
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
        .then(response => {
            addToast(t('toast.documentDeleted'), { appearance: 'success' });         
        }).catch(error => {
            console.log(error)
            addToast(t('toast.errorDeletingDocument'), { appearance: 'error' });
        });

        //remove from the list
        const docsFiltered = docs.filter((item) => item['doc_no'] !== doc_no);
        setDocs(docsFiltered);

    };

    const saveDocEdit = (doc) => {
        //remove from db
        setShowModalEdit(false);
        API.post('del_asset_docs', '/' + props.assetId, {      
            body: {
                doc_no: doc.doc_no,
            },
            headers: {
                'x-api-key': process.env.REACT_APP_API_KEY,        
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
        .then(response => {
           //post amended document
            API.post('asset_docs', '/' + props.assetId, {      
                body: doc,
                headers: {
                    'x-api-key': process.env.REACT_APP_API_KEY,        
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
            })
            .then(res => {
                setLoading(true);
                addToast(t('toast.documentSaved'), { appearance: 'success' });            
            }).catch(error => {
                console.log(error)
                addToast(t('toast.errorSavingDocument'), { appearance: 'error' });
            }); 
            
        }).catch(error => {
            console.log(error)
            addToast(t('toast.errorEditingDocument'), { appearance: 'error' });
        });

    };

    const schema = yup.object().shape({
        description: yup.string()
        .required(t('common.required')),  
        // file: yup.mixed()
        // .required('Required')
        // .test('fileSize', "File is too large", value => value.size <= FILE_SIZE) 
        });

        // , file: undefined
    const initialValues = { description: '', version: '' };

    return (
    <div className="AssetDocs">
        <section className="docs-upload">
        <h4>{t('docs.upload')}</h4>
        <Formik
            initialValues={initialValues}
            validationSchema={schema}
            onSubmit={ (values, { setSubmitting, resetForm }) => {
                if (file){
                    handleSubmit(values, { resetForm });
                    setSubmitting(false);
                } else {
                    addToast(t('docs.invalidFile'), { appearance: 'error' });
                }
            }}

            >
            {({values, errors, touched, handleChange, handleSubmit }) => (

        <form onSubmit={handleSubmit} className="docs-form">
        <Form.Group controlId="file" >
            <Form.Label>{t('fields.file')}</Form.Label>
            <Form.Control
                as="input"
                value={values.file}
                onChange={e => {setFile(e.target.files[0])}}
                type="file"
                  />
        </Form.Group>
        <Form.Group controlId="description" className={touched.description && errors.description ? "has-error" : null}>
            <Form.Label>{t('common.description')}</Form.Label>
            <Form.Control
                as="input"
                value={values.description}
                onChange={handleChange}
            />
            {touched.description && errors.description ? <div className="error-message">{errors.description}</div> : null}
        </Form.Group>
        <Form.Group controlId="version">
            <Form.Label>{t('fields.version')}</Form.Label>
            <Form.Control
                as="input"
                value={values.version}
                onChange={handleChange}
            />
        </Form.Group>
            <Button size="sm" variant="primary" className="docs-save" type="submit" disabled={upload}>
                {t('common.save')}
                { (!upload) ? (
                <FaFileUpload />
                ):(
                <Spinner size="sm" animation="border" role="status" variant="light" />
                )}
            </Button>
        </form>
            )}
            </Formik>
        </section>

        <section className="docs-list">
        <h4>{docs.length > 0 ? `${docs.length} ${docs.length === 1 ? t('common.document') : t('common.documents')}` : t('actions.documents')}</h4>
        {docs.length === 0 ? (
            <div className="docs-empty">{t('docs.none')}</div>
        ) : (
        <div className="docs-table">
            <div className="docs-row is-head">
                <span>{t('docs.doc')}</span>
                <span>{t('fields.filename')}</span>
                <span>{t('fields.lastUpdate')}</span>
                <span>{t('common.description')}</span>
                <span>{t('fields.version')}</span>
                <span />
            </div>
        { docs.map((item,i) => (
        <div key={i} className="docs-row">
            <span className="docs-no">{item.doc_no}</span>
            <a className="docs-file" href={item.url} target="_blank" rel="noopener noreferrer" download>{item.filename}</a>
            <span className="docs-date"><Moment local format='DD MMM YYYY' date={ item.date } /></span>
            <span className="docs-desc">{item.description || '—'}</span>
            <span className="docs-ver">{item.version || '—'}</span>
            <span className="docs-actions">
            <Button variant="outline-secondary" type="button" size="sm" onClick={() => handleShowEdit(item)} >
                <FaPencilAlt />
            </Button>
            <Button variant="outline-danger" type="button" size="sm" onClick={() => handleShow(item.doc_no)} >
                <FaTrashAlt />
            </Button>
            </span>
        </div>
        ))}
        </div>
        )}
        </section>

        <Modal className="text-dark border-danger" show={showModal} onHide={handleClose} animation={false} >
            <Modal.Header className="bg-danger text-light align-content-center" closeButton>
            <Modal.Title><h3><strong>{t('docs.deleteTitle')}</strong></h3></Modal.Title>
            </Modal.Header>
            <Modal.Body>{t('docs.deleteConfirm', { n: selDoc })}</Modal.Body>
            <Modal.Footer>
            <Button className="m-0 mr-2" variant="danger" onClick={()=>deleteDoc(selDoc)}>
                {t('actions.delete')}
            </Button>
            <Button className="m-0"  variant="secondary" onClick={handleClose}>
                {t('common.close')}
            </Button>
            </Modal.Footer>
        </Modal> 

        <Modal className="text-dark" show={showModalEdit} onHide={handleCloseEdit} animation={false} >
            <Modal.Header closeButton>
            <Modal.Title>{t('docs.editTitle')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="docs-edit-grid">
                    <div className="info-label">{t('fields.docNo')}</div>
                    <div className="info-value">{selDocEdit.doc_no}</div>
                    <div className="info-label">{t('fields.filename')}</div>
                    <div className="info-value">{selDocEdit.filename}</div>
                    <Form.Group controlId="e_description">
                        <Form.Label>{t('common.description')}</Form.Label>
                    <Form.Control
                        as="input"
                        value={selDocEdit.description || ''}
                        onChange={(e)=>{
                            setSelDocEdit({...selDocEdit, description: e.target.value})
                        }}
                    />
                    </Form.Group>
                    <Form.Group controlId="e_version">
                        <Form.Label>{t('fields.version')}</Form.Label>
                    <Form.Control
                        as="input"
                        value={selDocEdit.version || ''}
                        onChange={(e)=>{
                            setSelDocEdit({...selDocEdit, version: e.target.value})
                        }}
                    />
                    </Form.Group>
                </div>
            </Modal.Body>
            <Modal.Footer>
            <Button className="m-0 mr-2" variant="primary" size="sm" onClick={()=>saveDocEdit(selDocEdit)}>
                {t('common.save')}
            </Button>
            <Button className="m-0"  variant="secondary" size="sm" onClick={handleCloseEdit}>
                {t('common.close')}
            </Button>
            </Modal.Footer>
        </Modal> 

    </div>
)
}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
    };
};

export default connect(mapStateToProps )(AssetDocs);
